<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--home">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <app-progress-bar [routeName]="routeName"></app-progress-bar>
    <main class="vtz-review-container">
      @if(ballotType === 'POLL') {
      <h1 class="vtz-h1" id="main-title" i18n>Review Poll</h1>
      @if (this.returnMethod === 'PRINT') {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the poll question. <br>
        To confirm your selections, click the "Continue" button to print your poll for mailing.</p>
      }
      @if (this.returnMethod === 'ELECTRONIC' && (signatureRequired | async)) {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the poll question. <br>
        To confirm your selections, click the "Continue" button to sign your affidavit and submit your poll.</p>
      }
      @if (this.returnMethod === 'ELECTRONIC' && (signatureRequired | async) === false) {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the poll question. <br>
        To confirm your selections, click the "Submit" button to submit your poll.</p>
      }
      } @else {
      <!-- Petitions and Elections -->
      <h1 class="vtz-h1" id="main-title" i18n>Review Ballot</h1>
      @if (this.returnMethod === 'PRINT') {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the ballot. <br>
        To confirm your selections, click the "Continue" button to print your ballot for mailing.</p>
      }
      @if (this.returnMethod === 'ELECTRONIC' && (signatureRequired | async)) {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the ballot. <br>
        To confirm your selections, click the "Continue" button to sign your affidavit and cast your ballot.</p>
      }
      @if (this.returnMethod === 'ELECTRONIC' && (signatureRequired | async) === false) {
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Please review your selections below. <br>
        To modify a selection, click "change" to return to the ballot. <br>
        To confirm your selections, click the "Submit" button to cast your ballot.</p>
      }
      }
      <br>
      @for (contest of contests; track contest; let contestIndex = $index) {
      <div class="vtz-review-question">
        @if(ballotType === 'POLL') {
          <h2 class="vtz-h2" i18n> Question {{ contestIndex + 1 }} of {{ contests.length }}</h2>
        } @else {
          <h2 class="vtz-h2" i18n> Contest {{ contestIndex + 1 }} of {{ contests.length }}</h2>
        } 
        @if(stringHasHtml(contest.contest_name)) {
          <h2 class="vtz-h2">
            <div [innerHtml]="contest.contest_name"></div>
          </h2>
        } @else {
          <h2 class="vtz-h2">{{contest.contest_name}}</h2>
        }

        <!--------------------------------------R C V------------------------------------->
        @if ((contest.isRCV) && (contest.rankedStatements.length < +contest.question!.maxSelect!)) { <span i18n
          class="vtz-review-undervote-warning">
          You may rank {{ +contest.question!.maxSelect! - contest.rankedStatements.length }} more.
          </span>
          }
          <!------------------------------------NON   RCV---------------------------------------->
          @if ((!contest.isRCV)
          && ((contest.selections.length) < (contest.maxSelect ?? 1) && (!isDeclineChoiceSelected(contestIndex)))) {
            @if(ballotType==='POLL' ) { <span i18n class="vtz-review-undervote-warning">
            You may select up to {{ (contest?.maxSelect ?? 0) - (contest?.selections?.length ?? 0)}} more.
            </span>
            } @else {
            <span i18n class="vtz-review-undervote-warning">
              You may vote for up to {{ (contest?.maxSelect ?? 0) - (contest?.selections?.length ?? 0)}} more.
            </span>
            }
            }
            <!--------------------------------------R C V------------------------------------->
            @if (contest.isRCV) {
            <div class="vtz-review-selections">
              @if (contest.rankedStatements.length === 0) {
              <p class="vtz-review-selection vtz-text vtz-text--small vtz-text--bold" i18n>NO SELECTION(S) RECORDED</p>
              }
              @if (contest.rankedStatements.length > 0) {
              @for (candidate of contest.rankedStatements; track candidate; let i = $index ) {
              <div class="review-with-image-container">
                @if (!isStringEmpty(candidate.choices[0].choiceDetails?.imageUrl)) {
                <img class="review-image" src="{{candidate.choices[0].choiceDetails?.imageUrl}}"
                  [alt]="candidate.description">
                }
                <p i18n class="vtz-review-selection vtz-text vtz-text--small">{{ i + 1 }}: {{ candidate.description }}</p>
              </div>
              }
              }
              <button class="vtz-review-change-link" (click)="goToBallot(contestIndex)"
                [attr.aria-label]="'Change selection for' +contest.description" i18n>change</button>
            </div>
            }
            <!------------------------------------NON   RCV---------------------------------------->
            @if (!contest.isRCV) {
            <div class="vtz-review-selections">
              @if (contest.selections.length === 0) {
              <p class="vtz-review-selection vtz-text vtz-text--small vtz-text--bold" i18n>NO SELECTION(S) RECORDED</p>
              }
              @if (contest.selections.length > 0) {
              @for (choice of contest.selections; track choice) {
              <div class="review-with-image-container">
                @if (!isStringEmpty(choice.choiceDetails?.imageUrl)) {
                <img src="{{choice.choiceDetails?.imageUrl}}" class="review-image">
                }
                <p class="vtz-review-selection vtz-text vtz-text--small">{{ choice.description }}</p>
              </div>

              }
              }
              @if (!isAcclaimedSelected(contestIndex)) {
              <button #row class="vtz-review-change-link" (click)="goToBallot(contestIndex)"
                [attr.aria-label]="'Change selection for' +contest.description" i18n>change</button>
              }
            </div>
            }
            <!--------------------------------------------------------------------------------------->
      </div>
      }
      <div class="vtz-actions vtz-actions--top-none">
        @if (returnMethod === 'ELECTRONIC' && (signatureRequired | async)) {
        <button id="go-to-signature-button" class="button-primary" (click)="goToSignaturePage()"
          i18n="Button label">CONTINUE</button>
        }
        @if (returnMethod === 'ELECTRONIC' && (signatureRequired | async) === false) {
        <button id="open-ballot-submit-button" class="button-primary" (click)="openSubmitModal($event)"
          i18n="Button label">SUBMIT</button>
        }
        @if (returnMethod === 'PRINT') {
        <button id="go-to-print-button" class="button-primary" (click)="goToPrintPage()"
          i18n="Button label">CONTINUE</button>
        }
      </div>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>